/**
 * Environment detection helper.
 *
 * `test.testwisely.nl` = staging (Entree testkoppeling, geen echte schoolaccounts)
 * Anders = productie (echte Entree login)
 *
 * Zo kan dezelfde build naar beide subdomeinen — endpoint-keuze gebeurt
 * runtime op basis van `window.location.hostname`.
 */

export function isTestEnvironment() {
  if (typeof window === 'undefined') return false;
  return window.location.hostname === 'test.testwisely.nl';
}

export function getEntreeBasePath() {
  return isTestEnvironment() ? '/api/auth/entree-test' : '/api/auth/entree';
}

export function getFrontendOrigin() {
  if (typeof window === 'undefined') return 'https://testwisely.nl';
  return window.location.origin;
}
